import { User } from 'services/interface';

// The Explore Data (stats) page is restricted to authenticated OPSWAT staff only.
// Access is granted when the user is logged in AND their SSO email is on the @opswat.com domain.
const OPSWAT_EMAIL_REGEX = /@opswat\.com$/i;

const normalizeEmail = (email: string | undefined): string => (email ?? '').trim().toLowerCase();

export const isOpswatEmail = (email: string | undefined): boolean => OPSWAT_EMAIL_REGEX.test(normalizeEmail(email));

// The Threat Share Report is not released on staging and prod yet: hidden there for everyone, staff included. One
// gate for both the "Threat Share" nav item and every /explore-data route (WrapPage renders NotFound).
const STATS_PAGE_HIDDEN_ENVS: readonly string[] = ['staging', 'staging-pci', 'prod'];

export const canAccessStatsPage = (user: User | null | undefined): boolean =>
    !STATS_PAGE_HIDDEN_ENVS.includes(process.env.GATSBY_ENV ?? '') &&
    Boolean(user?.isLoggedIn) &&
    isOpswatEmail(user?.email);
